
import CopyConts from 'copy-to-clipboard'

/**
 *  拷贝方法
 */
export const MixinCopy = {
  methods: {
    /** 复制方法 */
    Copy(props) {
      const { conts = '', isMessage = true, msg = '', failMsg=''} = props
      if (conts) {
        CopyConts(conts)
        isMessage && this.$message({
          message: `${msg}`,
          type: 'success'
        })
      } else {
        isMessage && this.$message({
          message: `${failMsg}`,
          type: 'warning'
        })
      }
    }
  }
}





// WEBPACK FOOTER //
// ./src/mixins/comCopy.js